import React from "react";

export const IconMinus = () => (
  <svg width="14" height="16" viewBox="0 0 448 512">
    <path
      fill="currentColor"
      d="M432 256c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h352c17.7 0 32 14.3 32 32z"
    />
  </svg>
);
